module.exports = __webpack_public_path__ + "media/images/pic/hero/brodno-ce52b5b27e0fe9791632b919d7cd25c3.webp";